import { api } from '@/api';

export type UserEmailsResponse = Blob;

const userEmailsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserEmails: builder.query<UserEmailsResponse, void>({
      query: () => ({
        url: `admin-utils/user-emails`,
        method: 'GET',
        responseHandler: async (response) => {
          if (!response.ok) {
            throw new Error(`Failed to fetch user emails: ${response.status} ${response.statusText}`);
          }
          return await response.blob();
        },
        cache: 'no-cache',
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetUserEmailsQuery } = userEmailsApi;
